/* eslint-disable no-empty-label,no-mixed-spaces-and-tabs */
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI, { Message } from 'element-ui'
import Antd from 'ant-design-vue'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/el-theme/index.css' // global css
import './styles/index.scss' // global css
import './utils/bee.min'
import './script/filters'
import './script/directive'
import '@/assets/icons' // icon 12312
import perHistory, { getPathWithKey } from './router/permissionHistory'
import { PathKeys } from './config/componentList'
import $log from './utils/log'
import $reg from './utils/reg'
const echarts = require('echarts')

$log(process.env)

Vue.prototype.$log = $log
Vue.prototype.$getPathWithKey = getPathWithKey
Vue.prototype.$pathKeys = PathKeys
Vue.prototype.$perHistory = perHistory
Vue.use(Antd)
Vue.use(ElementUI)
Vue.prototype.$message = Message
Vue.prototype.$regs = $reg
Vue.prototype.$echarts = echarts

//导入样式
import './styles/common.css'
import './assets/font/iconfont.css'
import './styles/element-reset.css'
Vue.config.productionTip = false
import '@/assets/icons' // icon 12312
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js